
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1r7p7", function(module, exports) {

$parcel$export(module.exports, "BrowserStorageControlsInit", () => $5372da7267fcd229$export$1e5524c82dfa4c29);

var $eUqFw = parcelRequire("eUqFw");

var $gmFE1 = parcelRequire("gmFE1");
const $5372da7267fcd229$export$1e5524c82dfa4c29 = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $gmFE1.initializeControls)({
            product: 'Jira'
        });
    }, []);
    return null;
};

});
parcelRegister("gmFE1", function(module, exports) {

$parcel$export(module.exports, "initializeControls", () => $07e94fddd0214724$export$919040c32a62c7db);

var $1J3ZG = parcelRequire("1J3ZG");
var $3J72S = parcelRequire("3J72S");
var $6lAvk = parcelRequire("6lAvk");
var $iBOme = parcelRequire("iBOme");

var $4uLct = parcelRequire("4uLct");
parcelRequire("t9yuT");
var $5y1hw = parcelRequire("5y1hw");

var $hbI7b = parcelRequire("hbI7b");

var $j3AtR = parcelRequire("j3AtR");
const $07e94fddd0214724$export$919040c32a62c7db = async (args = {})=>{
    try {
        (0, $4uLct.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $3J72S.isSSR)()) return;
        const isBSCFlagEnabled = await (0, $iBOme.pollForBrowserControlsFlag)();
        if (!isBSCFlagEnabled) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $1J3ZG.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (!isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $hbI7b.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $4uLct.getBscGlobalState)().webStorageEnabled;
        if (!isWebStorageControlsEnabled) return;
        await (0, $j3AtR.createWebStoragePassthrough)((0, $5y1hw.StorageType).LocalStorage);
        await (0, $j3AtR.createWebStoragePassthrough)((0, $5y1hw.StorageType).SessionStorage);
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("iBOme", function(module, exports) {

$parcel$export(module.exports, "pollForBrowserControlsFlag", () => $ea6e32d3bbc94c51$export$cc1c284801c32a43);
/* eslint-disable @atlaskit/platform/no-invalid-feature-flag-usage */ 
var $XHGTv = parcelRequire("XHGTv");
const $ea6e32d3bbc94c51$var$TIME_IN_MS = 1000;
const $ea6e32d3bbc94c51$var$MAX_WAIT_TIME = 300 * $ea6e32d3bbc94c51$var$TIME_IN_MS;
const $ea6e32d3bbc94c51$var$INITIAL_WAIT_TIME = 2 * $ea6e32d3bbc94c51$var$TIME_IN_MS;
const $ea6e32d3bbc94c51$export$cc1c284801c32a43 = async (waitTime = $ea6e32d3bbc94c51$var$INITIAL_WAIT_TIME, totalElapsedTime = 0)=>{
    return $ea6e32d3bbc94c51$var$pollForFeatureFlag('platform.moonjelly.browser-storage-controls', waitTime, totalElapsedTime, $ea6e32d3bbc94c51$export$cc1c284801c32a43);
};
const $ea6e32d3bbc94c51$var$pollForFeatureFlag = (featureFlag, waitTime = $ea6e32d3bbc94c51$var$INITIAL_WAIT_TIME, totalElapsedTime = 0, pollingFuncReference)=>{
    /*
    We don't know exactly if/when the FF will be enabled, so we want to exponentially poll from 2s to a max of ~5min
    If it never comes back as 'true' then we assume that:
      a) it's correctly set to false and thus we don't override the document.cookie behavior
      b) the FF client failed to load in time, don't override the behavior by making false assumptions
  */ const shouldCancelPolling = totalElapsedTime > $ea6e32d3bbc94c51$var$MAX_WAIT_TIME;
    if (shouldCancelPolling) return Promise.resolve(false);
    // eslint-disable-next-line @atlaskit/platform/static-feature-flags
    if (!(0, $XHGTv.fg)(featureFlag)) {
        const newWaitTime = waitTime * 2;
        // Use the max if new wait time exceeds it
        const cappedWaitTime = Math.min(newWaitTime, $ea6e32d3bbc94c51$var$MAX_WAIT_TIME);
        return new Promise((resolve)=>{
            setTimeout(async ()=>{
                const updatedElapsedTime = totalElapsedTime + cappedWaitTime;
                const newFlagState = await pollingFuncReference(cappedWaitTime, updatedElapsedTime);
                resolve(newFlagState);
            }, cappedWaitTime);
        });
    }
    return Promise.resolve(true);
};

});

parcelRegister("t9yuT", function(module, exports) {

$parcel$export(module.exports, "findStorageTarget", () => $f2d839b37396cfc1$export$14921bfc334334c0);
$parcel$export(module.exports, "StorageType", () => (parcelRequire("5y1hw")).StorageType);

var $4uLct = parcelRequire("4uLct");
var $3J72S = parcelRequire("3J72S");

var $6lAvk = parcelRequire("6lAvk");

var $epRiJ = parcelRequire("epRiJ");

var $5TOtj = parcelRequire("5TOtj");

var $5y1hw = parcelRequire("5y1hw");

var $g9bVO = parcelRequire("g9bVO");
var $GM7yV = parcelRequire("GM7yV");
var $i1Yk3 = parcelRequire("i1Yk3");
class $f2d839b37396cfc1$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $5TOtj.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $6lAvk.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        if ((0, $4uLct.getBscGlobalState)().webStorageEnabled) return true;
        (0, $6lAvk.Logger).warn('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return null;
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6lAvk.Logger).warn(`${this.storageType} is unavailable. Failed to get item.`);
            return null;
        }
        const retrievedItem = (0, $g9bVO.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) return;
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6lAvk.Logger).warn(`${this.storageType} is unavailable. Failed to set item.`);
            return;
        }
        const itemSetStatus = await (0, $GM7yV.setStorageItem)(key, value, this.storageType, this.storage);
        (0, $6lAvk.Logger).warn(`${itemSetStatus === (0, $epRiJ.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) return;
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6lAvk.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item.`);
            return;
        }
        const itemSetStatus = (0, $i1Yk3.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $6lAvk.Logger).warn(`${itemSetStatus === (0, $epRiJ.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isWebStorageEnabled) return;
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $6lAvk.Logger).warn(`${this.storageType} is unavailable. Failed to remove item.`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isWebStorageEnabled) return null;
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isWebStorageEnabled) return 0;
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isWebStorageEnabled) return;
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $3J72S.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $f2d839b37396cfc1$export$c8cc3ffd3f2c1d2f = new $f2d839b37396cfc1$export$8e4a3cf07a10930b(window?.localStorage, (0, $5y1hw.StorageType).LocalStorage);
const $f2d839b37396cfc1$export$edbae459bdf957a5 = new $f2d839b37396cfc1$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $5y1hw.StorageType).SessionStorage);
const $f2d839b37396cfc1$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $5y1hw.StorageType).LocalStorage]: $f2d839b37396cfc1$export$c8cc3ffd3f2c1d2f,
        [(0, $5y1hw.StorageType).SessionStorage]: $f2d839b37396cfc1$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("5TOtj", function(module, exports) {

$parcel$export(module.exports, "BSCIndexedDB", () => $7776203ca7f1ff71$export$36328b3bcbe4623a);

var $3J72S = parcelRequire("3J72S");

var $6lAvk = parcelRequire("6lAvk");
class $7776203ca7f1ff71$export$fde2a4e0e57f47e {
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $6lAvk.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>(event)=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>(event)=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6lAvk.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $6lAvk.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $6lAvk.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $6lAvk.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $3J72S.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 1);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $6lAvk.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                let request = objectStore.add('SET-BY-PACKAGE', recordKey);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $6lAvk.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $7776203ca7f1ff71$export$36328b3bcbe4623a = new $7776203ca7f1ff71$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("5y1hw", function(module, exports) {

$parcel$export(module.exports, "StorageType", () => $1aa4b5efb6a07925$export$d5f3ec63cad061d9);
var $1aa4b5efb6a07925$export$d5f3ec63cad061d9;
(function(StorageType) {
    StorageType["LocalStorage"] = "localStorage";
    StorageType["SessionStorage"] = "sessionStorage";
})($1aa4b5efb6a07925$export$d5f3ec63cad061d9 || ($1aa4b5efb6a07925$export$d5f3ec63cad061d9 = {}));

});

parcelRegister("g9bVO", function(module, exports) {

$parcel$export(module.exports, "getStorageItem", () => $b57c794b5b8e10b8$export$e612bb1301d659de);

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");
const $b57c794b5b8e10b8$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        // Allow all items by default, but gate sending events by the flag.
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) (0, $1J3ZG.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("GM7yV", function(module, exports) {

$parcel$export(module.exports, "setStorageItem", () => $2360a46c8aab5eec$export$5ee8760f703d9d62);

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $3aUPE = parcelRequire("3aUPE");

var $6lAvk = parcelRequire("6lAvk");

var $5TOtj = parcelRequire("5TOtj");

var $epRiJ = parcelRequire("epRiJ");
const $2360a46c8aab5eec$export$5ee8760f703d9d62 = async (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) {
        const eventAttributes = {
            wasRejected: false,
            itemKey: itemKey,
            storageType: storageType
        };
        try {
            browserStorage.setItem(itemKey, value);
            return (0, $epRiJ.Status).SUCCESS;
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                attributes: eventAttributes,
                message: `Failed to set ${storageType} item. ${e.message || ''}`
            });
            return (0, $epRiJ.Status).FAILED;
        }
    }
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $3aUPE.isProcessingAllowedByPreferences)({
        itemKey: itemKey
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $1J3ZG.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $5TOtj.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $epRiJ.Status).SUCCESS;
        } else return (0, $epRiJ.Status).BLOCKED;
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $epRiJ.Status).BLOCKED;
    }
};

});
parcelRegister("3aUPE", function(module, exports) {

$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $88d3702b74c9a41b$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $izgK8 = parcelRequire("izgK8");

var $epRiJ = parcelRequire("epRiJ");

var $038zE = parcelRequire("038zE");
const $88d3702b74c9a41b$export$2c141b1c00f3e482 = (itemKey, { startsWith: startsWith })=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $88d3702b74c9a41b$export$69d5b68d01f4a366 = (itemKey, storageControlsData, cachedKeysDataProperty)=>{
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let keys = storageControlsData[cachedKeysDataProperty];
    // Find direct match in keys
    if (itemKey in Object(keys)) itemCategoryNumber = keys[itemKey];
    else // Find pattern match or null
    itemCategoryNumber = $88d3702b74c9a41b$export$2c141b1c00f3e482(itemKey, patterns);
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $epRiJ.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $epRiJ.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $epRiJ.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $epRiJ.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $epRiJ.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $88d3702b74c9a41b$export$ec8ce5237293e4a4 = async (itemKey, cachedKeysDataProperty)=>{
    const storageControlsData = await (0, $038zE.loadStorageControlsData)();
    if (!storageControlsData) return null;
    else return $88d3702b74c9a41b$export$69d5b68d01f4a366(itemKey, storageControlsData, cachedKeysDataProperty);
};
const $88d3702b74c9a41b$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, cachedKeysDataProperty: cachedKeysDataProperty = (0, $epRiJ.CachedKeysDataProperty).Cookies })=>{
    let shouldProcessItem;
    // Skipping this because storageControlsData does not have actual web storage data
    // TODO: JELLY-808: Remove this skip once we have the cached LS/SS data in our categories.json
    const shouldSkip = cachedKeysDataProperty === (0, $epRiJ.CachedKeysDataProperty).LocalStorage || cachedKeysDataProperty === (0, $epRiJ.CachedKeysDataProperty).SessionStorage;
    // TODO: Remove this check when categories.json returns the proper keys
    const itemCategory = shouldSkip ? (0, $epRiJ.PreferenceCategory).StrictlyNecessary : await $88d3702b74c9a41b$export$ec8ce5237293e4a4(itemKey, cachedKeysDataProperty);
    if (itemCategory === (0, $epRiJ.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $izgK8.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("izgK8", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $b81a7b33e9021718$export$1de6a888ae076ff8);

var $XHGTv = parcelRequire("XHGTv");

var $f8OZU = parcelRequire("f8OZU");

var $85idY = parcelRequire("85idY");

var $b4VDn = parcelRequire("b4VDn");

var $huW21 = parcelRequire("huW21");
async function $b81a7b33e9021718$export$1de6a888ae076ff8() {
    // Use V001 pattern without the V2 FF enabled
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) {
        const packedPrefs = (0, $b4VDn.getCookie)((0, $f8OZU.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $huW21.unpackUserPreferencesCookie)(packedPrefs);
    }
    let packedLocalPrefs = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (!packedLocalPrefs) {
        const consentToken = await (0, $85idY.getConsentToken)();
        return consentToken ? (0, $huW21.unpackUserPreferencesCookie)(consentToken) : undefined;
    }
    return (0, $huW21.unpackUserPreferencesCookie)(packedLocalPrefs);
}

});
parcelRegister("85idY", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $391d5185569e2bfc$export$f1b8f2ca713fca08);

var $f8OZU = parcelRequire("f8OZU");

var $b4VDn = parcelRequire("b4VDn");

var $53MVb = parcelRequire("53MVb");

var $4TcP6 = parcelRequire("4TcP6");

var $hWRvQ = parcelRequire("hWRvQ");
const $391d5185569e2bfc$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $hWRvQ.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $53MVb.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $b4VDn.getCookie)((0, $f8OZU.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $4TcP6.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $4TcP6.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $4TcP6.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("53MVb", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $e87a9db0df2659c7$export$b5282052fc15e1ae);

var $f8OZU = parcelRequire("f8OZU");

var $b4VDn = parcelRequire("b4VDn");
const $e87a9db0df2659c7$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $b4VDn.getCookie)((0, $f8OZU.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("4TcP6", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $5947d7e9e7fd3832$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $5947d7e9e7fd3832$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $5947d7e9e7fd3832$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $5947d7e9e7fd3832$export$b3365240280cb3c3);

var $fP0zk = parcelRequire("fP0zk");

var $f8OZU = parcelRequire("f8OZU");

var $40nlu = parcelRequire("40nlu");

var $lIW4M = parcelRequire("lIW4M");
const $5947d7e9e7fd3832$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $40nlu.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $fP0zk.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $5947d7e9e7fd3832$export$8e560d0760f733a2(consentToken);
    $5947d7e9e7fd3832$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("lIW4M", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $6d2869955a851487$export$93509ff9a62ee022);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");
const $6d2869955a851487$export$93509ff9a62ee022 = (key, value, attributes)=>{
    try {
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) (0, $1J3ZG.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("hWRvQ", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $4f85d7ab666d3f6a$export$c515de1cc9cebc71);

var $dEf7A = parcelRequire("dEf7A");

var $huW21 = parcelRequire("huW21");
const $4f85d7ab666d3f6a$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $dEf7A.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $huW21.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});





parcelRegister("i1Yk3", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $6fd2b80f0a53d6a8$export$f1b0c189562aa9fd);

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");

var $epRiJ = parcelRequire("epRiJ");

var $5TOtj = parcelRequire("5TOtj");
const $6fd2b80f0a53d6a8$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) {
            (0, $1J3ZG.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
                attributes: eventAttributes
            });
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
            (0, $5TOtj.BSCIndexedDB).setRecord(itemKey).then(()=>{
            // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
            }).catch((e)=>{
                // Rethrow to the above catch clause since this is async within a sync func
                throw new Error(e.message || '');
            });
        }
        browserStorage.setItem(itemKey, value);
        return (0, $epRiJ.Status).SUCCESS;
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $epRiJ.Status).FAILED;
    }
};

});


parcelRegister("hbI7b", function(module, exports) {

$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $57e99bd88ebb82f8$export$45a5573b04db016c);

var $6lAvk = parcelRequire("6lAvk");

var $5k1KZ = parcelRequire("5k1KZ");
const $57e99bd88ebb82f8$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $6lAvk.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $5k1KZ.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("5k1KZ", function(module, exports) {

$parcel$export(module.exports, "getSetCookieOverride", () => $6bd6d17694d0aa80$export$b7364c41ddbfdb0a);

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $3aUPE = parcelRequire("3aUPE");

var $6lAvk = parcelRequire("6lAvk");

var $epRiJ = parcelRequire("epRiJ");
const $6bd6d17694d0aa80$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $1J3ZG.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                // Attempt to set a known cookie that was set from outside the package
                (0, $3aUPE.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        if ((0, $XHGTv.fg)('platform.moonjelly.block-unknown-cookies')) return;
                        else {
                            if (!itemHasCategory) return originalSetter.apply(document, [
                                originalCookieValue
                            ]);
                            else return;
                        }
                    },
                    cachedKeysDataProperty: (0, $epRiJ.CachedKeysDataProperty).Cookies
                });
            } catch (e) {
                (0, $6lAvk.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("j3AtR", function(module, exports) {

$parcel$export(module.exports, "createWebStoragePassthrough", () => $5fa12e449cd6e47b$export$619fe705922e5d61);

var $6lAvk = parcelRequire("6lAvk");

var $5TOtj = parcelRequire("5TOtj");

var $t9yuT = parcelRequire("t9yuT");

var $iZ6ZE = parcelRequire("iZ6ZE");
const $5fa12e449cd6e47b$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $t9yuT.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $6lAvk.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $5TOtj.BSCIndexedDB).isAvailable) {
        (0, $6lAvk.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $5TOtj.BSCIndexedDB).isBooted) // If we've yet to invoke booting of the IDB service, ensure we do it here.
    await (0, $5TOtj.BSCIndexedDB).boot();
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $iZ6ZE.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    Object.defineProperty(window, storageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("iZ6ZE", function(module, exports) {

$parcel$export(module.exports, "setItemOverride", () => $2c4f15c921a9982f$export$b4469df6294ea6aa);

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $3aUPE = parcelRequire("3aUPE");

var $6lAvk = parcelRequire("6lAvk");
parcelRequire("t9yuT");
var $5y1hw = parcelRequire("5y1hw");

var $epRiJ = parcelRequire("epRiJ");
const $2c4f15c921a9982f$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $1J3ZG.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                // Attempt to set a known item key that was set from outside the package
                (0, $3aUPE.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                        if ((0, $XHGTv.fg)('platform.moonjelly.block-unknown-cookies')) return;
                        else if (!itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    cachedKeysDataProperty: storageType === (0, $5y1hw.StorageType).LocalStorage ? (0, $epRiJ.CachedKeysDataProperty).LocalStorage : (0, $epRiJ.CachedKeysDataProperty).SessionStorage
                });
            } catch (e) {
                (0, $6lAvk.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});





//# sourceMappingURL=async-browser-storage-controls-init.271b5a75.js.map
